module.exports = __webpack_public_path__ + "static/DM01-5143645c6d740d8f6d449332896ffe7b.jpg";